var Breakpoints;
(function (Breakpoints) {
    Breakpoints[Breakpoints["mobile"] = 0] = "mobile";
    Breakpoints[Breakpoints["tablet"] = 768] = "tablet";
    Breakpoints[Breakpoints["desktop"] = 960] = "desktop";
    Breakpoints[Breakpoints["desktopWide"] = 1248] = "desktopWide";
})(Breakpoints || (Breakpoints = {}));
export default Breakpoints;
/**
 * @internal
 */
export const maximumWidth = 1760;
/**
 * @internal
 */
export const maximumMediaWidth = 1920;
/**
 * @internal
 */
export const maximumStretchedWidth = 1984;
